<template>
    <cc-preview-module title="申请人" :data="transformData"></cc-preview-module>
</template>

<script>
    // 预览模块
    import ccPreviewModule from '@/components/common/preview-module/index.vue';
    // 数据转换
    import transformData from '@/views/mixins/transform-data.js';
    // 代码工具类
    import codeUtils from '@/utils/code.js';
    export default {
        mixins: [transformData],
        components: {
            ccPreviewModule
        },
        props: {
            // 申请人
            data: {
                type: Array
            }
        },
        data() {
            return {
                // sqr: []
                // 转换之后的数据
                transformData: []
            }
        },
        methods: {

            /**
             * 获取转换数据
             * @returns {Array} 转换后的数据列表
             * */
            async getTransformData(data) {
                const _transformData = [];
                // 诉讼地位map对象
                const _codeMap = await codeUtils.getCodeMap('702000');
                // 循环遍历组装数组
                data.forEach(itemData => {
                    const _transformItemData = [];
                    _transformItemData.push(this.getRowData('申请人类型', itemData.cSqrlxText));
                    // 自然人
                    if (itemData.cSqrlx === '1') {
                        _transformItemData.push(this.getRowData('姓名', itemData.cSqrxm));
                        // _transformItemData.push(this.getRowData('诉讼地位', itemData.nSsdwText));
                        _transformItemData.push(this.getRowData('诉讼地位', codeUtils.getKeyName(_codeMap, itemData.nSsdw)));
                        _transformItemData.push(this.getRowData('性别', itemData.cSqrxbText));
                        _transformItemData.push(this.getRowData('民族', itemData.nMzText));
                        _transformItemData.push(this.getRowData('年龄', itemData.nNl));
                        _transformItemData.push(this.getRowData('出生日期', itemData.dtSqrbirthday));
                        _transformItemData.push(this.getRowData('证件类型', itemData.cZjlxText));
                        _transformItemData.push(this.getRowData('证件号码', itemData.cZjh, false, true));
                        _transformItemData.push(this.getRowData('手机号码', itemData.cPhonone));
                        _transformItemData.push(this.getRowData('固定电话', itemData.cGh));
                        _transformItemData.push(this.getRowData('经常居住地', itemData.cTxdz, false, true));
                    } else {
                        _transformItemData.push(this.getRowData('单位名称', itemData.cQymc, false, true));
                        _transformItemData.push(this.getRowData('诉讼地位', itemData.nSsdwText));
                        _transformItemData.push(this.getRowData('统一社会信用代码', itemData.cQyzzjgdm, false, true));
                        _transformItemData.push(this.getRowData('单位性质', itemData.cDwxzText));
                        _transformItemData.push(this.getRowData('法定代表人', itemData.cQyfr));
                        _transformItemData.push(this.getRowData('手机号码', itemData.cPhonone));
                        _transformItemData.push(this.getRowData('固定电话', itemData.cGh));
                        _transformItemData.push(this.getRowData('单位地址', itemData.cTxdz, false, true));
                    }
                    _transformData.push(_transformItemData);
                })
                return _transformData;
            }
        },
        async created() {
            // 转换之后的数据
            this.transformData = await this.getTransformData(this.data);
        }
    }
</script>
